module.exports = __webpack_public_path__ + "static/media/LogoInformation.76a58f44.svg";